import request from '@/utils/axios';

export const getWorksReplies            = p         => request.get(`/community/open/reply/works/${p}`);
export const getUserMessageBoard        = p         => request.get(`/community/open/reply/user/${p}`);

export const reply                      = p         => request.post('/community/reply', p);
export const replyWorks                 = (wid, p)  => request.post(`/community/reply/works/${wid}`, p);
export const leaveMessage               = (uid, p)  => request.post(`/community/reply/user/${uid}`, p);

export const greatReply                 = p         => request.put(`/community/reply/${p}`);
export const deleteReply                = p         => request.delete(`/community/reply/${p}`);
